// from general.js
/* global proposalMessageFormatter */

// Used by Rollup Handlebars plugin
// ignore unused exports default
export default function (Handlebars) {
    Handlebars.registerHelper('showOneOffTeacherComment', function (sourceid, options) {
        if (sourceid == 4 || sourceid == 4096) {
            return options.fn(this);
        }
        return options.inverse(this);
    });

    Handlebars.registerHelper('showGiftCodeText', function (original, options) {
        if (original.giftCode &&
            original.author.id != original.giftCode.purchaserDonorId &&
            !original.author.correspondsToGrantAccount &&
            !original.author.correspondsToInternalDonorAccount) {
            return options.fn(this);
        }
        return options.inverse(this);
    });

    Handlebars.registerHelper('showGiftCodeSection', function (original, options) {
        // show if grant account and not a placeholder image
        if (original.author.correspondsToGrantAccount && original.author.photoURL && original.author.photoURL.indexOf('placeholder-avatars') === -1 && original.author.photoURL.indexOf('anonymous') === -1) {
            return options.fn(this);
        }
        // If multiple codes were redeemed in the cart, do not pick a winner.
        if (original.multipleGiftCodesToAcknowledge) {
            return options.inverse(this);
        }
        // show if bought with grant account gift code (when the grant account has a logo)
        if (original.giftCode && (original.author.id != original.giftCode.purchaserDonorId) && original.giftCode.purchaserGrantAccountLogo) {
            return options.fn(this);
        }

        return options.inverse(this);
    });

    Handlebars.registerHelper('isGiftCodeAnonymous', function (giftCode, options) {
        if (giftCode.purchaseWasAnonymous || giftCode.purchaserDonorPageStatus.indexOf('HIDDEN') > -1) {
            return options.fn(this);
        }
        return options.inverse(this);
    });

    Handlebars.registerHelper('userAvatar', function (author, className) {
        if (author.correspondsToGrantAccount) {
            return '';
        }
        if (!author.photoURL) {
            return '';
        }
        if (author.type == 'T') {
            className = 'classroom';
        }
        return '<span class="user-avatar ' + className + '" style="background-image:url(' + author.photoURL + ')"></span>';
    });

    Handlebars.registerHelper('userPageURL', function (author) {
        if (author.vanityURL) {
            return baseURL + author.vanityURL;
        } else if (author.type == 'T') {
            return baseURL + 'classroom/' + author.id;
        } else if (author.type == 'D') {
            return baseURL + 'donor/' + author.id;
        }
    });

    Handlebars.registerHelper('photoURLExistsAndIsNotPlaceholder', function (photoURL, options) {
        if (photoURL && photoURL.indexOf('placeholder-avatars') === -1 && photoURL.indexOf('anonymous') === -1) {
            return options.fn(this);
        }
        return options.inverse(this);
    });

    Handlebars.registerHelper('locationAndDonorTeacherRelationship', function (author, modifiesDonorLabel, messageSourceId) {
        const getLocation = function (author) {
            if (author.correspondsToGrantAccount) {
                return '';
            }
            if (author.city) {
                return author.city + ', ' + author.stateAbbreviated;
            } else if (author.state) {
                return author.state;
            }
            return '';
        };

        let result = '';
        const location = getLocation(author);
        if (modifiesDonorLabel) {
            const commaAfterDonorTeacherRelationship = messageSourceId === 1;
            result += proposalMessageFormatter.getLocationAndDonorTeacherRelationship(location, author.donorTeacherRelationship, commaAfterDonorTeacherRelationship);
        } else {
            result += 'A ';
            if (author.donorTeacherRelationship !== '') {
                result += author.donorTeacherRelationship;
            } else {
                result += 'donor';
            }
            if (location.trim() !== '') {
                result += ' ' + location.trim();
            }
        }
        return result;
    });
}
